var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.user.permissions.user_show)?_c('div',{staticClass:"user"},[_c('BaseTable',{attrs:{"settings":_vm.settings,"fields":_vm.fields,"items":_vm.result,"searchTerm":_vm.$store.state.searchTerm,"sortBy":"familyname","sortOrder":"desc","rowClass":"familyname","tableId":"1"}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1e3e942","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/User.vue
// module id = 203
// module chunks = 1